import { IPrinterRepository, PaperSizeEntity, ScaleEntity, ResponseValueObject } from '@gishub/domain';
import { axiosClient } from '../http/axios-client';

export class PrinterRepository implements IPrinterRepository {
  async getPaperSizes(): Promise<ResponseValueObject<PaperSizeEntity[]>> {
    const response = await axiosClient.get<ResponseValueObject<PaperSizeEntity[]>>('/printer/paper-sizes');
    return response.data;
  }

  async getScales(paperSizeId: string, bbox: string, landscape: boolean, srid: number): Promise<ResponseValueObject<ScaleEntity[]>> {
    const response = await axiosClient.get<ResponseValueObject<ScaleEntity[]>>(`/printer/paper-sizes/${paperSizeId}/scales`, {
      params: { bbox, landscape, srid },
    });
    return response.data;
  }
}
